import { Routes } from '@angular/router';
import { DefaultComponent } from '../app/components/default/default.component';
import { NotFoundComponent } from '../app/components/not-found/not-found.component';
import { ErrorPageComponent } from '../app/components/error-page/error-page.component';
import { TemplateViewComponent } from '../app/components/template/template-view.component';
import { PublicLoginComponent } from '../app/components/public-login/public-login.component';
import { CanDeactivateGuard } from '../app/guards/can-deactivate.guard';
import { CanActivateGuard } from '../app/guards/can-activate.guards';
import { TopBarComponent } from '../app/components/top-bar/top-bar.component';

const config = (<any>window).ftClientConfig;

function getAuthRoute(config): Routes {
  if (config.authentication?.disableLocalLogin === true) {
    return [];
  }

  return [{
    path: 'auth',
    loadChildren: () => import('../app/modules/auth/auth.module').then(m => m.AuthModule)
  }];
}

const authRoutes: Routes = [];
// push after initialization so the initializer is an ArrayLiteralExpression
authRoutes.push(...getAuthRoute(config));

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/default',
    pathMatch: 'full'
  },
  {
    path: 'default',
    component: DefaultComponent,
    canActivate: [CanActivateGuard]
  },
  ...authRoutes,
  {
    path: 'search',
    loadChildren: () => import('../app/modules/search/search.module').then(m => m.SearchModule)
  },
  {
    path: 'form',
    component: TopBarComponent,
    children: [
      {
        path: '',
        component: DefaultComponent,
        pathMatch: 'full'
      },
      {
        path: ':id',
        component: TemplateViewComponent,
        canDeactivate: [CanDeactivateGuard],
        canActivate: [CanActivateGuard]
      },
      {
        path: ':id/:templateId',
        component: TemplateViewComponent,
        canDeactivate: [CanDeactivateGuard],
        canActivate: [CanActivateGuard]
      }
    ]
  },
  {
    path: 'formNoNavBar/:id',
    component: TemplateViewComponent,
    data: { noNavBar: true },
    canDeactivate: [CanDeactivateGuard],
    canActivate: [CanActivateGuard]
  },
  {
    path: 'notFound',
    component: NotFoundComponent
  },
  {
    // Generic error page (e.g. Keycloak auth failures). Marked isAuthView so the
    // init/auth-gate flow doesn't intercept it for unauthenticated users. Must be
    // a top-level route (not under the auth module) so it stays reachable even
    // when disableLocalLogin removes the auth routes.
    path: 'error',
    component: ErrorPageComponent,
    data: { isAuthView: true }
  },
  {
    path: ':accountPublicURL',
    component: PublicLoginComponent
  },
  {
    path: ':accountPublicURL/:paramRoute/:paramQuery',
    component: PublicLoginComponent
  },
  {
    path: ':accountPublicURL/:paramRoute',
    component: PublicLoginComponent
  },
  {
    path: ':accountPublicURL/:paramRoute/:paramQuery/:override',
    component: PublicLoginComponent
  }
]; 